export default class Industry {
	id;
	name;
	constructor(initialState) {
		Object.assign(this, initialState);
	}
}


// WEBPACK FOOTER //
// ./src/models/Industry.js